import { render, staticRenderFns } from "./ModaldraftOrder.vue?vue&type=template&id=57f87803&"
import script from "./ModaldraftOrder.vue?vue&type=script&lang=js&"
export * from "./ModaldraftOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports